import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({

  dragableDiv: {
    justifyContent: 'center', alignItems: 'center', height: 45, width: 120, position: "relative", zIndex: 12, cursor: "pointer",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 30, width: 70,
    },
  },
  shadowDiv: {
    justifyContent: 'center', alignItems: 'center', height: 45, width: 120, marginLeft: 10, marginTop: 10, cursor: "pointer", border: "1.5px solid #003e4c", borderRadius: 5, backgroundColor: "#003e4c", zIndex: 0, position: 'absolute',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 30, width: 70,
    },
  },
  textContainer: {
    justifyContent: 'center', alignItems: 'center', height: 45, width: 120, position: "relative", zIndex: 1, cursor: "pointer", border: "1.5px solid #003e4c", borderRadius: 5, backgroundColor: "#fff",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 30, width: 70,
    },
  },
  text:{
    color: "#003e4c", fontSize: 19, fontFamily: "Rubik", letterSpacing: 1, textTransform: "uppercase",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 12
    },
  },

  questionImg: {
    width: "150px",
    height: "150px",
    marginRight: "2.5rem",
    cursor: "pointer",
    // position: 'absolute',
    zIndex: "5",
    userDrag: 'none',
    // [mobileScreen(theme)]: {
    //   width: "100px",
    //   height: "100px",
    //   marginRight: "1.5rem",
    // }
  },

  serviceTitle: {
    color: "#003e4c",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Oswald",
    marginBottom: "4px",
    textTransform: "uppercase",
    // [mobileScreen(theme)]: {
    //   fontSize: "15px",
    //   marginBottom: "2px"
    // }
  },

  serviceDesc: {
    color: "#003e4c",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Rubik",
    maxWidth: "350px",
    lineHeight: "1.2",
    // [mobileScreen(theme)]: {
    //   fontSize: "12px",
    //   maxWidth: "200px",
    // }
  },

  iconTraceBack: {
    width: "143px",
    height: "143px",
    position: "absolute",
    zIndex: "3",
    top: "0",
    borderRadius: "50%",
    border: "3px dashed #003e4c",
    backgroundColor: "#ecf2f1",
    // [mobileScreen(theme)]: {
    //   width: "93px",
    //   height: "93px",
    // }
  },

  draggableMainContainer: {
    width: "150px",
    height: "150px",
    position: "relative",
    // [mobileScreen(theme)]: {
    //   width: "100px",
    //   height: "100px",
    // }
  },

  draggableContainer: {
    width: "150px",
    height: "150px",
    position: "absolute",
    zIndex: "10",
    // [mobileScreen(theme)]: {
    //   width: "100px",
    //   height: "100px",
    // }
  },

  draggableElement: {
    width: "550px",
    flexWrap: "nowrap",
    // [mobileScreen(theme)]: {
    //   width: "325px",
    // }
  }

});

export default styles;
